import SmartLink from '../../lib/includes/components/component.smartlink';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import React from "react";

const HeaderTop = (props) => {

	return <div className="site-header-top">
		<div className="container container--max">
			{props.menu.menus?.top_menu &&
				<ul className="nav justify-content-end">
					{props.menu.menus.top_menu.items.filter(item => item.parent == 0).map((item, i) => {
						return <li key={item.id} className="nav-item">
							<SmartLink activeClassName="current" className="nav-link" url={item.url}
									   target={item.target}>{item.title}</SmartLink>
						</li>
					})}
				</ul>
			}
		</div>
	</div>
};
export default connect(
	state => {
		return {
			menu: state.menuState,
		}
	}
)(HeaderTop);
